import { render, staticRenderFns } from "./JiShiDownClock.vue?vue&type=template&id=4df34aca&scoped=true"
import script from "./JiShiDownClock.vue?vue&type=script&lang=js"
export * from "./JiShiDownClock.vue?vue&type=script&lang=js"
import style0 from "./JiShiDownClock.vue?vue&type=style&index=0&id=4df34aca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df34aca",
  null
  
)

export default component.exports